import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import BaseModal from "../../theme/modals/BaseModal";
import BaseForm from "../../theme/forms/BaseForm";
import validators from "../../../utils/forms/validators";
import {projectStartSearch} from "../../../utils/projectStartSearch";


function AddressSearchModal({ visible, onClose = () => {} }) {

    let [searchTerm, setSearchTerm] = useState(null);
    let [errMsg, setErrMsg] = useState(null)

    const history = useHistory()

    const formInputs = [
        {
            type: 'text',
            dataKey: 'address',
            inputClasses: 'is-medium',
            controlClasses: 'full-width',
            placeholder: 'Enter Address',
            ...validators.isStringOfMinLength(4)
        }
    ]

    const onSubmit = ({ address }) => {
        setErrMsg(null);
        return projectStartSearch(address, history)
            .then(res => {
                if (Object.keys(res).includes("reject")) {
                    setErrMsg(res.reject);
                }
            })
    }

    return (

        <BaseModal visible={visible || true}>
            <h3 className="is-size-4 has-text-primary">Start a new project</h3>
            <p className="has-text-danger mt-2">{errMsg}</p>
             <BaseForm
                inputs={formInputs}
                // hideDefaultButtons
                buttonWrapperClass="is-justify-content-flex-end"
                onSubmit={onSubmit}
                onCancel={onClose}
                submitButtonText="Get Financing"
                disableAutocomplete
             />
        </BaseModal>

    )
}

export default AddressSearchModal;